import React from 'react';

const Card = ({ title, subtitle, description, imagePlacement = 'right', imgSrc, linkTo }) => {
    return (
        <div className="w-full flex justify-center py-6 px-4 sm:px-8 md:px-16">
            <div className="w-full lg:w-3/4 bg-white px-4 sm:px-6 lg:px-8 py-8 sm:py-10 rounded-2xl border bg-secondary-light shadow-lg">
                <div
                    className={`flex flex-col ${imagePlacement === 'left' ? 'lg:flex-row-reverse' : 'lg:flex-row'} justify-between lg:items-center gap-6 lg:gap-10`}
                >
                    {/* Text Content */}
                    <div
                        className="flex flex-col items-start text-left w-full"
                    >
                        <h3 className="text-2xl sm:text-3xl lg:text-4xl text-primary font-bold mb-2 sm:mb-4">
                            {title}
                        </h3>
                        {subtitle && (
                            <h4 className="text-xl sm:text-2xl lg:text-3xl text-secondary-dark font-semibold mb-2 sm:mb-4">
                                {subtitle}
                            </h4>
                        )}
                        <p className="text-sm sm:text-base lg:text-lg text-secondary-dark font-medium mb-4">
                            {description}
                        </p>
                        {linkTo && (
                            <a 
                                href={linkTo}
                                className="inline-block bg-primary text-white px-6 py-3 rounded-lg font-semibold hover:bg-primary-dark transition-colors"
                            >
                                mehr erfahren
                            </a>
                        )}
                    </div>

                    {/* Image Container */}
                    <div className="w-full flex justify-center lg:block">
                        <img
                            alt="card img"
                            className="rounded-2xl w-full max-w-full sm:max-w-[500px] md:max-w-[600px] lg:max-w-[700px] h-auto object-contain"
                            src={imgSrc}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Card;